import React from 'react';
import MerchantDetailsComponentProps from '../merchantDetailsComponentProps';
import BidComponentBuilder from './BidComponentBuilder';

const ExternalComponents: React.FC<MerchantDetailsComponentProps> = props => {
    return <>
        <BidComponentBuilder merchantId={props.merchant.id} />
    </>;
}

export default ExternalComponents;